<template>
    <div>

        <nav class="pushy pushy-right" data-focus="#first-link">
            <div class="pushy-content">
                <p class="pushy-tit">전체메뉴</p>
                <p class="pushy-close">닫기</p>
                <!-- <ul>
                    <li class="pushy-link"><a id="first-link" :href="$cp + 'main'">홈</a></li>
                    <li class="pushy-link"><a :href="$cp + 'realtime'">실시간 도시 현황</a></li>
                    <li class="pushy-link"><a :href="$cp + 'biz'">미래를 그리는 강남</a></li> -->
                    <!-- <li class="pushy-link"><a :href="$cp + 'biz?selectedTab=policy'">정책 강남</a></li> -->
                    <!-- <li class="pushy-link"><a :href="$cp + 'lifemap'">강남 Maps</a></li>
                    <li class="pushy-link"><a :href="$cp + 'indicator'">분야별 지표</a></li> -->
                    <!-- <li><a href="javascript:void(0)" @click.prevent="openSeoulRtd()"><b>도시데이터</b></a></li> -->
                    <!-- <li class="pushy-link"><a :href="$cp + 'news'">강남 브리핑</a></li>
                    <li class="pushy-link"><a :href="$cp + 'openapi'">공공데이터</a></li>
                    <li class="pushy-link"><a :href="$cp + 'read'">데이터로 분석한 구정</a></li>
                    <li class="pushy-link"><a :href="$cp + 'intro'">시스템 소개</a></li>
                </ul> -->
                <ul>
                    <li class="pushy-link" v-for="menu in this.menuList" :key="menu.menuSeq">
                        <a id="first-link" :href="$cp + menu.menuUrl">{{ menu.menuNm }}</a>
                    </li>
                </ul>
            </div>
        </nav>

        <div class="nav">
            <a :href="$cp + 'realtime'" class="nav_i01"><span>실시간도시</span></a>
            <a :href="$cp + 'lfcnvnc'" class="nav_i02"><span>생활편의 정보</span></a>
            <a :href="$cp + 'indicator'" class="nav_i03"><span>데이터강남</span></a>
            <a :href="$cp + 'news'" class="nav_i04"><span>강남브리핑</span></a>
            <a href="https://www.gangnam.go.kr/mobile/main.do" target="_blank" class="nav_i05 m-visible"><span>구홈페이지</span></a>
            <a href="https://www.gangnam.go.kr/main.do" target="_blank" class="nav_i05 pc-visible"><span>구홈페이지</span></a>
        </div>
        <div class="btn_close" @click.prevent="setShowBottom()">닫기</div>
        <div class="btn_open" @click.prevent="setShowBottom()">열기</div>
    </div>
</template>

<script>
import commonConstMixin from "@/stores/common.const.mixin.js";
import pushy from "@/libs/pushy.js";
import {mapGetters} from "vuex";
import { $_WC, $_TYPE } from "@/confs/common.const";

export default {
    name: "GNB",
    data() {
        return {
            href: window.location.href,
            currentUser: this.$session.get('currentUser'),
            menuList: this.$session.get('menuList'),
            upperMenu: this.$session.get('upperMenu'),
            mainMenu: this.$session.get('mainMenu'),
            UNDEF: $_TYPE.UNDEF,
            MAIN_MENU_SEQ: $_WC.mainMenuSeq,
        };
    },
    computed: {
        ...mapGetters({
            showBtm: 'getShowBtm',
        }),
    },
    mounted() {
        pushy.pushy(jQuery);
    },
    methods: {
        setShowBottom(){
            this.$store.dispatch('SET_SHOW_BTM', !this.showBtm);
        },
        openSeoulRtd() {
            window.open('https://data.seoul.go.kr/SeoulRtd/', '_self');
        },
    },
    mixins: [commonConstMixin],
}
</script>
